import axios from "axios";
const apiInstance = axios.create();
try {
    apiInstance.defaults.baseURL = BASE_API_URL;
    apiInstance.interceptors.request.use(config => {
        var _a;
        const updatedConfig = config;
        if ((_a = config.url) === null || _a === void 0 ? void 0 : _a.includes("/ui/logs")) {
            updatedConfig.headers.Authorization = TOKEN;
        }
        return updatedConfig;
    });
}
catch (error) {
    // this one is only needed for cypress tests
    console.error("Error creating axios instance:", error);
}
export default apiInstance;
